import { inject, Injectable } from '@angular/core';
import { AdminApplicationStore } from './admin-application.store';
import { IEnrollmentTagType, IUserTagType } from '@lb/api/mylb/interfaces';

@Injectable()
export class AdminStateService {
	private readonly adminStore = inject(AdminApplicationStore);

	public enrollmentTagTypes = this.adminStore.enrollmentTagTypes;
	public userTagTypes = this.adminStore.userTagTypes;
	public loaded = this.adminStore.adminStateLoaded;
	public loading = this.adminStore.adminStateLoading;

	loadData(): void {
		this.adminStore.loadTagTypes();
	}

	deleteUserTagType(userTagTypeID: number): void {
		this.adminStore.deleteUserTagType(userTagTypeID);
	}

	deleteEnrollmentTagType(enrollmentTagTypeID: number): void {
		this.adminStore.deleteEnrollmentTagType(enrollmentTagTypeID);
	}

	createUserTagType(tagType: IUserTagType): void {
		this.adminStore.createUserTagType(tagType);
	}

	createEnrollmentTagType(tagType: IEnrollmentTagType): void {
		this.adminStore.createEnrollmentTagType(tagType);
	}

	updateUserTagType(id: number, tagType: IUserTagType): void {
		this.adminStore.updateUserTagType(id, tagType);
	}

	updateEnrollmentTagType(id: number, tagType: IEnrollmentTagType): void {
		this.adminStore.updateEnrollmentTagType(id, tagType);
	}
}
